<template>
  <el-dialog
    title='上传安装包'
    :visible.sync='visible'
    width='800px'
    center
    :close-on-click-modal='false'
    @close='closeDialog'>
    <el-form :model='form' label-width='120px' :rules='rules' ref='ruleForm'
             size='medium'>
      <el-form-item label='安装包：' prop='file'>
        <el-upload
          ref='upload'
          class='upload-demo'
          accept='.apk'
          :action='uploadUrl'
          :auto-upload='true'
          :show-file-list='false'
          :data='uploadData'
          :on-change='uploadChange'
          :on-success='(res) => uploadImgFun(res)'
          :file-list='uploadList'
          :limit='1'
        >
          <el-button size='small' type='primary'>点击上传</el-button>
          <div slot='tip' style='margin-top: 6px;margin-left: 10px'>支持扩展名：.pak</div>
        </el-upload>
        <div v-for='(item,index) in uploadList'>
          <div class='upload'>
            <div
              style='white-space:nowrap; text-overflow:ellipsis;overflow:hidden;width: 360px'>
              {{ item.name }}
            </div>
            <div>
              <i class='el-icon-loading' v-if="item.status !=='success'"></i>
              <i class='el-icon-upload2 pointer' @click='uploadClick(item,index)'></i>
              <i class='el-icon-delete pointer' @click='handleRemove(item,index)'></i></div>
          </div>
        </div>
      </el-form-item>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' @click='submit'>
          确定
        </el-button>
        <el-button size='medium' class='resetBtn' @click='closeDialog'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { uploadPackage } from '@/service/DevOps';
  import { baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    name: 'index',
    components: { divBorder },
    props:{
      // 1 手持机 2 app
      uploadType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        visible: false,
        form: {
          file: '',
        },
        rules: {
          file: [
            {
              required: true,
              message: '请上传安装包',
              trigger: 'change',
            },
          ],
        },
        uploadUrl: '',
        uploadData: {},
        uploadList: [],
        uploadFlag: false,//替换
        uploadIndex: '',//替换索引
        dialogUploadList: [],
      };
    },
    methods: {
      submit() {
        this.form.file = this.uploadList;
        const submitParams = {
          name: this.form.file[0].response.data.name,
          url: this.form.file[0].response.data.url,
          fileType: this.form.file[0].response.data.fileType,
          handsetOrPhone: this.uploadType
        };
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await uploadPackage(submitParams);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.closeDialog();
          }
        });
      },
      openDialog() {
        let token = getSessionStore('token');
        this.uploadUrl = `${baseUrl}/platform/handset/apkUpload?access_token=${token}`;
        this.visible = true;
      },
      closeDialog() {
        this.visible = false;
        this.$refs.ruleForm.resetFields();
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.uploadList.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.uploadList = fileList;
        }
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status == -1) {
            this.uploadList.splice(this.uploadList.indexOf(file), 1);
          }
        }
      },
      uploadImgFun(res) {
        if (res.status == 0) {
          this.$message.success(res.message);
          if (this.uploadFlag) {//如果为替换，得到索引值进行替换
            this.dialogUploadList.splice(this.uploadIndex, 1, { 'id': res.data.id });
            this.uploadFlag = false;
          } else {
            this.dialogUploadList.push({ 'id': res.data.id });
          }
        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;
        }
      },
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();
      },
      handleRemove(item, index) {
        this.uploadList.splice(index, 1);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .el-form-item {
    margin-top: 18px;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px 0;

    button {
      margin: 0 15px;
    }
  }

  .upload-demo {
    display: flex;
  }

  .upload {
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      margin-right: 10px;
    }

    i:hover {
      color: #00e1ff;
    }

  }
</style>
